import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Plane } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_1c7269e2-1feb-426d-b007-6b7d8cae6132/artifacts/w1x3gw05_tum%20logo%20square.jpeg" 
                alt="TUM Holidays" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm leading-relaxed mb-4">
              <span className="font-semibold text-white">To Ur Manzil</span> - Your trusted travel partner for unforgettable journeys. We specialize in domestic and international tour packages, creating memories that last a lifetime.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-red-500 transition-colors flex items-center gap-2">
                  <Plane size={16} />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/domestic" className="hover:text-red-500 transition-colors flex items-center gap-2">
                  <Plane size={16} />
                  Domestic Packages
                </Link>
              </li>
              <li>
                <Link to="/international" className="hover:text-red-500 transition-colors flex items-center gap-2">
                  <Plane size={16} />
                  International Packages
                </Link>
              </li>
              <li>
                <Link to="/why-choose-us" className="hover:text-red-500 transition-colors flex items-center gap-2">
                  <Plane size={16} />
                  Why Choose Us
                </Link>
              </li>
              <li>
                <Link to="/visa" className="hover:text-red-500 transition-colors flex items-center gap-2">
                  <Plane size={16} />
                  Visa Application
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-red-500 transition-colors flex items-center gap-2">
                  <Plane size={16} />
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li>• Tour Packages</li>
              <li>• Flight Booking</li>
              <li>• Cab Services</li>
              <li>• Adventure Activities</li>
              <li>• Tourist Visa Assistance</li>
              <li>• Hotel Reservations</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-red-500 mt-1 flex-shrink-0" />
                <div>
                  <a href="tel:+918283950765" className="hover:text-red-500 transition-colors block">
                    +91-8283950765
                  </a>
                  <a href="tel:+917837714489" className="hover:text-red-500 transition-colors block">
                    +91-7837714489
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-red-500 mt-1 flex-shrink-0" />
                <a href="mailto:info@tumholidays.com" className="hover:text-red-500 transition-colors">
                  info@tumholidays.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-red-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold">Panchkula Office:</p>
                  <p>Sector 8, Panchkula, Haryana</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-red-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold">Parwanoo Office:</p>
                  <p>Sector 1, SCF 14, Parwanoo (HP)</p>
                </div>
              </li>
            </ul>

            {/* Social Media */}
            <div className="mt-6">
              <h4 className="text-white font-semibold mb-3">Follow Us</h4>
              <div className="flex gap-4">
                <a 
                  href="https://www.facebook.com/tumholidays" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-2 bg-gray-800 rounded-full hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                >
                  <Facebook size={20} />
                </a>
                <a 
                  href="https://www.instagram.com/tumholidays?igsh=MWd6ZXFxYjliZnJtaQ==" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-2 bg-gray-800 rounded-full hover:bg-pink-600 transition-all duration-300 hover:scale-110"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>
            © {new Date().getFullYear()} TUM Holidays. All rights reserved. | Designed with ❤️ for travelers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;